import { Logo } from "@client/components/logo";
import { Page } from "@client/components/utils/Page";
import { Card, CardContent } from "@sfc/ui";
import { LoginPanel } from "./LoginButton";

export default function Login() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  return (
    <Page className="flex items-center justify-center">
      <div className="mx-auto flex w-full max-w-sm flex-col gap-6">
        <div className="flex flex-col items-center gap-3 text-center">
          <Logo />
          <div className="flex flex-col gap-1">
            <h1 className="text-2xl font-bold">Welcome to S-Process</h1>
            <p className="text-sm text-muted-foreground">
              Sign in to your workspace
            </p>
          </div>
        </div>

        <Card>
          <CardContent>
            <LoginPanel />
          </CardContent>
        </Card>

        {params.error && (
          <div className="text-center text-sm text-red-500">
            Error: {params.error}
          </div>
        )}
      </div>
    </Page>
  );
}
